import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FolderTree, RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DriveFolders = () => {
  const { companies } = useData();
  const [d, setD] = useState(null);
  const [map, setMap] = useState({});
  const [root, setRoot] = useState("");
  const load = () => api.get("/drive/folders").then((r) => { setD(r.data); setMap(r.data.company_folders); setRoot(r.data.root_name); }).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      await api.put("/drive/company-folders", { company_folders: map, root_name: root });
      toast.success("Cartelle salvate");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const sync = async () => {
    try {
      const { data } = await api.post("/drive/sync");
      toast.success(`${data.moved} file spostati su Drive`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!d) return null;
  return (
    <div className="mt-6 border-t pt-5" data-testid="drive-folders">
      <div className="flex items-center gap-2 font-semibold"><FolderTree className="h-4 w-4" />Cartelle per azienda esecutrice</div>
      <p className="mt-1 text-sm text-muted-foreground">Ogni foto o allegato di un ordine va in: cartella principale / cartella dell'azienda che esegue l'ordine / codice pratica.</p>
      <div className="mt-3 flex max-w-md items-center gap-2">
        <Input value={root} onChange={(e) => setRoot(e.target.value)} data-testid="drive-root-name" />
        <span className={`shrink-0 text-xs ${d.root_id ? "text-emerald-700" : "text-red-600"}`} data-testid="drive-root-status">{d.root_id ? "trovata" : "non trovata"}</span>
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {companies.map((c) => (
          <label key={c.id} className="flex items-center justify-between gap-3 border p-2 text-sm">
            <span className="font-semibold">{c.code}</span>
            <select className="h-9 w-56 border bg-white px-2" value={map[c.id] || ""} onChange={(e) => setMap({ ...map, [c.id]: e.target.value })} data-testid={`drive-folder-${c.code}`}>
              <option value="">— nessuna cartella —</option>
              {d.subfolders.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </label>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <Button onClick={save} data-testid="drive-folders-save">Salva cartelle</Button>
        <Button variant="outline" onClick={sync} data-testid="drive-sync-button"><RefreshCw className="mr-1 h-4 w-4" />Sposta ora su Drive</Button>
        <span className="text-xs text-muted-foreground" data-testid="drive-pending">{d.pending} file in attesa di essere spostati</span>
      </div>
    </div>
  );
};
